module.exports = __webpack_public_path__ + "img/logo.e2b2248c.png";